/* @sravni/react-design-system version 0.2.65 */
var css = "._lf51zd {\n  width: 100%;\n}\n";
var modules_95586cb6 = {"container":"_lf51zd"};
import "../../../assets/components/NumberInput/src/NumberInput-72ea9175.css";

export default modules_95586cb6;
export { css };
